/* tslint:disable */
/* eslint-disable */
/**
 * Plant-GenAI service
 * Plant-GenAI REST API documentation    develop - *******
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
export const JobDtoActionEnum = {
    GenerateAudio: 'GENERATE_AUDIO',
    GenerateVideo: 'GENERATE_VIDEO',
    RewriteText: 'REWRITE_TEXT',
    Search: 'SEARCH',
    Unknown: 'Unknown'
};
export const JobDtoStatusEnum = {
    Created: 'CREATED',
    Inprogress: 'INPROGRESS',
    Complete: 'COMPLETE',
    Failed: 'FAILED'
};
/**
 * Gender of the voice
 */
export const VoiceGenderDto = {
    Female: 'FEMALE',
    Male: 'MALE'
};
/**
 * AudioApi - axios parameter creator
 */
export const AudioApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Generate audio
         * @param {GenerateAudioDto} generateAudioDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        audioControllerGenerateAudio: (generateAudioDto_1, ...args_1) => __awaiter(this, [generateAudioDto_1, ...args_1], void 0, function* (generateAudioDto, options = {}) {
            // verify required parameter 'generateAudioDto' is not null or undefined
            assertParamExists('audioControllerGenerateAudio', 'generateAudioDto', generateAudioDto);
            const localVarPath = `/v1/audio/generateAudio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(generateAudioDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get voices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        audioControllerGetVoices: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/v1/audio/voices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AudioApi - functional programming interface
 */
export const AudioApiFp = function (configuration) {
    const localVarAxiosParamCreator = AudioApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Generate audio
         * @param {GenerateAudioDto} generateAudioDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        audioControllerGenerateAudio(generateAudioDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.audioControllerGenerateAudio(generateAudioDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudioApi.audioControllerGenerateAudio']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get voices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        audioControllerGetVoices(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.audioControllerGetVoices(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudioApi.audioControllerGetVoices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AudioApi - factory interface
 */
export const AudioApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AudioApiFp(configuration);
    return {
        /**
         *
         * @summary Generate audio
         * @param {GenerateAudioDto} generateAudioDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        audioControllerGenerateAudio(generateAudioDto, options) {
            return localVarFp.audioControllerGenerateAudio(generateAudioDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get voices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        audioControllerGetVoices(options) {
            return localVarFp.audioControllerGetVoices(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AudioApi - object-oriented interface
 */
export class AudioApi extends BaseAPI {
    /**
     *
     * @summary Generate audio
     * @param {GenerateAudioDto} generateAudioDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    audioControllerGenerateAudio(generateAudioDto, options) {
        return AudioApiFp(this.configuration).audioControllerGenerateAudio(generateAudioDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get voices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    audioControllerGetVoices(options) {
        return AudioApiFp(this.configuration).audioControllerGetVoices(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FilesApi - axios parameter creator
 */
export const FilesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} fileRoute Route to the generated file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1StaticFileRouteGet: (fileRoute_1, ...args_1) => __awaiter(this, [fileRoute_1, ...args_1], void 0, function* (fileRoute, options = {}) {
            // verify required parameter 'fileRoute' is not null or undefined
            assertParamExists('v1StaticFileRouteGet', 'fileRoute', fileRoute);
            const localVarPath = `/v1/static/{fileRoute}`
                .replace(`{${"fileRoute"}}`, encodeURIComponent(String(fileRoute)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FilesApi - functional programming interface
 */
export const FilesApiFp = function (configuration) {
    const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} fileRoute Route to the generated file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1StaticFileRouteGet(fileRoute, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1StaticFileRouteGet(fileRoute, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FilesApi.v1StaticFileRouteGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * FilesApi - factory interface
 */
export const FilesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FilesApiFp(configuration);
    return {
        /**
         *
         * @param {string} fileRoute Route to the generated file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1StaticFileRouteGet(fileRoute, options) {
            return localVarFp.v1StaticFileRouteGet(fileRoute, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FilesApi - object-oriented interface
 */
export class FilesApi extends BaseAPI {
    /**
     *
     * @param {string} fileRoute Route to the generated file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1StaticFileRouteGet(fileRoute, options) {
        return FilesApiFp(this.configuration).v1StaticFileRouteGet(fileRoute, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * JobsApi - axios parameter creator
 */
export const JobsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns the most recent jobs, sorted and paginated according to the provided parameters.
         * @summary Retrieves a paginated list of AI jobs
         * @param {JobsControllerFindJobsSortingDirectionEnum} [sortingDirection] Sort direction of the jobs.
         * @param {number} [pageNumber] Page number to retrieve (pagination with 50 items per page).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsControllerFindJobs: (sortingDirection_1, pageNumber_1, ...args_1) => __awaiter(this, [sortingDirection_1, pageNumber_1, ...args_1], void 0, function* (sortingDirection, pageNumber, options = {}) {
            const localVarPath = `/v1/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (sortingDirection !== undefined) {
                localVarQueryParameter['sortingDirection'] = sortingDirection;
            }
            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a job by its ID (authenticated)
         * @param {string} id Job\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsControllerGetJobById: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('jobsControllerGetJobById', 'id', id);
            const localVarPath = `/v1/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * JobsApi - functional programming interface
 */
export const JobsApiFp = function (configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns the most recent jobs, sorted and paginated according to the provided parameters.
         * @summary Retrieves a paginated list of AI jobs
         * @param {JobsControllerFindJobsSortingDirectionEnum} [sortingDirection] Sort direction of the jobs.
         * @param {number} [pageNumber] Page number to retrieve (pagination with 50 items per page).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsControllerFindJobs(sortingDirection, pageNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jobsControllerFindJobs(sortingDirection, pageNumber, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['JobsApi.jobsControllerFindJobs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get a job by its ID (authenticated)
         * @param {string} id Job\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsControllerGetJobById(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jobsControllerGetJobById(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['JobsApi.jobsControllerGetJobById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * JobsApi - factory interface
 */
export const JobsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = JobsApiFp(configuration);
    return {
        /**
         * Returns the most recent jobs, sorted and paginated according to the provided parameters.
         * @summary Retrieves a paginated list of AI jobs
         * @param {JobsControllerFindJobsSortingDirectionEnum} [sortingDirection] Sort direction of the jobs.
         * @param {number} [pageNumber] Page number to retrieve (pagination with 50 items per page).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsControllerFindJobs(sortingDirection, pageNumber, options) {
            return localVarFp.jobsControllerFindJobs(sortingDirection, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a job by its ID (authenticated)
         * @param {string} id Job\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsControllerGetJobById(id, options) {
            return localVarFp.jobsControllerGetJobById(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * JobsApi - object-oriented interface
 */
export class JobsApi extends BaseAPI {
    /**
     * Returns the most recent jobs, sorted and paginated according to the provided parameters.
     * @summary Retrieves a paginated list of AI jobs
     * @param {JobsControllerFindJobsSortingDirectionEnum} [sortingDirection] Sort direction of the jobs.
     * @param {number} [pageNumber] Page number to retrieve (pagination with 50 items per page).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    jobsControllerFindJobs(sortingDirection, pageNumber, options) {
        return JobsApiFp(this.configuration).jobsControllerFindJobs(sortingDirection, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a job by its ID (authenticated)
     * @param {string} id Job\&#39;s id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    jobsControllerGetJobById(id, options) {
        return JobsApiFp(this.configuration).jobsControllerGetJobById(id, options).then((request) => request(this.axios, this.basePath));
    }
}
export const JobsControllerFindJobsSortingDirectionEnum = {
    Ascending: 'ascending',
    Descending: 'descending'
};
/**
 * SearchAssistantApi - axios parameter creator
 */
export const SearchAssistantApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Search contents and get a summary
         * @param {SearchDto} searchDto Search data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAssistantControllerRequestSearch: (searchDto_1, ...args_1) => __awaiter(this, [searchDto_1, ...args_1], void 0, function* (searchDto, options = {}) {
            // verify required parameter 'searchDto' is not null or undefined
            assertParamExists('searchAssistantControllerRequestSearch', 'searchDto', searchDto);
            const localVarPath = `/v1/search-assistant/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SearchAssistantApi - functional programming interface
 */
export const SearchAssistantApiFp = function (configuration) {
    const localVarAxiosParamCreator = SearchAssistantApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Search contents and get a summary
         * @param {SearchDto} searchDto Search data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAssistantControllerRequestSearch(searchDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchAssistantControllerRequestSearch(searchDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SearchAssistantApi.searchAssistantControllerRequestSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * SearchAssistantApi - factory interface
 */
export const SearchAssistantApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SearchAssistantApiFp(configuration);
    return {
        /**
         *
         * @summary Search contents and get a summary
         * @param {SearchDto} searchDto Search data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAssistantControllerRequestSearch(searchDto, options) {
            return localVarFp.searchAssistantControllerRequestSearch(searchDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SearchAssistantApi - object-oriented interface
 */
export class SearchAssistantApi extends BaseAPI {
    /**
     *
     * @summary Search contents and get a summary
     * @param {SearchDto} searchDto Search data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAssistantControllerRequestSearch(searchDto, options) {
        return SearchAssistantApiFp(this.configuration).searchAssistantControllerRequestSearch(searchDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TextAssistantApi - axios parameter creator
 */
export const TextAssistantApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Rewrite text
         * @param {RewriteTextDto} rewriteTextDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textAssistantControllerRewriteText: (rewriteTextDto_1, ...args_1) => __awaiter(this, [rewriteTextDto_1, ...args_1], void 0, function* (rewriteTextDto, options = {}) {
            // verify required parameter 'rewriteTextDto' is not null or undefined
            assertParamExists('textAssistantControllerRewriteText', 'rewriteTextDto', rewriteTextDto);
            const localVarPath = `/v1/text-assistant/rewriteText`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(rewriteTextDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TextAssistantApi - functional programming interface
 */
export const TextAssistantApiFp = function (configuration) {
    const localVarAxiosParamCreator = TextAssistantApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Rewrite text
         * @param {RewriteTextDto} rewriteTextDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textAssistantControllerRewriteText(rewriteTextDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.textAssistantControllerRewriteText(rewriteTextDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TextAssistantApi.textAssistantControllerRewriteText']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * TextAssistantApi - factory interface
 */
export const TextAssistantApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TextAssistantApiFp(configuration);
    return {
        /**
         *
         * @summary Rewrite text
         * @param {RewriteTextDto} rewriteTextDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textAssistantControllerRewriteText(rewriteTextDto, options) {
            return localVarFp.textAssistantControllerRewriteText(rewriteTextDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TextAssistantApi - object-oriented interface
 */
export class TextAssistantApi extends BaseAPI {
    /**
     *
     * @summary Rewrite text
     * @param {RewriteTextDto} rewriteTextDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    textAssistantControllerRewriteText(rewriteTextDto, options) {
        return TextAssistantApiFp(this.configuration).textAssistantControllerRewriteText(rewriteTextDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VideoApi - axios parameter creator
 */
export const VideoApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Creates an asynchronous job to generate an avatar video from text. Returns the job identifier so you can track its progress.
         * @summary Create a video generation job
         * @param {GenerateVideoDto} generateVideoDto Text, voice and avatar selection to generate the video.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoControllerGenerateVideo: (generateVideoDto_1, ...args_1) => __awaiter(this, [generateVideoDto_1, ...args_1], void 0, function* (generateVideoDto, options = {}) {
            // verify required parameter 'generateVideoDto' is not null or undefined
            assertParamExists('videoControllerGenerateVideo', 'generateVideoDto', generateVideoDto);
            const localVarPath = `/v1/video/generateVideo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(generateVideoDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all video avatars and their available styles. Useful for selecting an avatar when generating videos.
         * @summary Retrieve the list of available video avatars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoControllerGetVideoAvatars: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/v1/video/avatars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VideoApi - functional programming interface
 */
export const VideoApiFp = function (configuration) {
    const localVarAxiosParamCreator = VideoApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates an asynchronous job to generate an avatar video from text. Returns the job identifier so you can track its progress.
         * @summary Create a video generation job
         * @param {GenerateVideoDto} generateVideoDto Text, voice and avatar selection to generate the video.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoControllerGenerateVideo(generateVideoDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.videoControllerGenerateVideo(generateVideoDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['VideoApi.videoControllerGenerateVideo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns all video avatars and their available styles. Useful for selecting an avatar when generating videos.
         * @summary Retrieve the list of available video avatars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoControllerGetVideoAvatars(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.videoControllerGetVideoAvatars(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['VideoApi.videoControllerGetVideoAvatars']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * VideoApi - factory interface
 */
export const VideoApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VideoApiFp(configuration);
    return {
        /**
         * Creates an asynchronous job to generate an avatar video from text. Returns the job identifier so you can track its progress.
         * @summary Create a video generation job
         * @param {GenerateVideoDto} generateVideoDto Text, voice and avatar selection to generate the video.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoControllerGenerateVideo(generateVideoDto, options) {
            return localVarFp.videoControllerGenerateVideo(generateVideoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all video avatars and their available styles. Useful for selecting an avatar when generating videos.
         * @summary Retrieve the list of available video avatars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoControllerGetVideoAvatars(options) {
            return localVarFp.videoControllerGetVideoAvatars(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VideoApi - object-oriented interface
 */
export class VideoApi extends BaseAPI {
    /**
     * Creates an asynchronous job to generate an avatar video from text. Returns the job identifier so you can track its progress.
     * @summary Create a video generation job
     * @param {GenerateVideoDto} generateVideoDto Text, voice and avatar selection to generate the video.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoControllerGenerateVideo(generateVideoDto, options) {
        return VideoApiFp(this.configuration).videoControllerGenerateVideo(generateVideoDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all video avatars and their available styles. Useful for selecting an avatar when generating videos.
     * @summary Retrieve the list of available video avatars
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videoControllerGetVideoAvatars(options) {
        return VideoApiFp(this.configuration).videoControllerGetVideoAvatars(options).then((request) => request(this.axios, this.basePath));
    }
}
